﻿export const UserRole = Object.freeze({
    Admin: 'Admin',
    CompanyOwner: 'Company Owner',
    CompanyAdmin: 'Company Admin',
    User: 'User',
    Collaborator: 'Collaborator'
});
